import * as Yup from 'yup';

export const LoginFormScheme = Yup.object().shape({
	type: Yup.string().nullable(),
	login: Yup.string()
		.nullable()
		.when('type', {
			is: (type?: string) => {
				return !type || type !== '3';
			},
			then: (schema) => {
				return schema.required('Обязательное поле');
			},
		}),
	password: Yup.string()
		.nullable()
		.when('type', {
			is: (type?: string) => {
				return !type || type !== '3';
			},
			then: (schema) => {
				return schema.required('Обязательное поле');
			},
		}),

	pultId: Yup.string()
		.nullable()
		.when('type', {
			is: (type?: string) => {
				return !!type && (type === '1' || type === '3');
			},
			then: (schema) => {
				return schema.required('Обязательное поле');
			},
		}),
});
